__turbopack_context__.v({
  "actions": "NotificationMenu-module__q23PdG__actions",
  "container": "NotificationMenu-module__q23PdG__container",
  "content": "NotificationMenu-module__q23PdG__content",
  "empty": "NotificationMenu-module__q23PdG__empty",
  "list": "NotificationMenu-module__q23PdG__list",
});
